// extracted by mini-css-extract-plugin
export var ignore = "_6r-1";
export var mapping = "_6r-0";
export var range = "_6r-4";
export var savings = "_6r-3";
export var settings = "_6r-2";